"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutSettingsT = exports.TimeoutSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class TimeoutSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTimeoutSettings(bb, obj) {
        return (obj || new TimeoutSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTimeoutSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TimeoutSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    duration() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startTimeoutSettings(builder) {
        builder.startObject(1);
    }
    static addDuration(builder, duration) {
        builder.addFieldFloat32(0, duration, 0.0);
    }
    static endTimeoutSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTimeoutSettings(builder, duration) {
        TimeoutSettings.startTimeoutSettings(builder);
        TimeoutSettings.addDuration(builder, duration);
        return TimeoutSettings.endTimeoutSettings(builder);
    }
    unpack() {
        return new TimeoutSettingsT(this.duration());
    }
    unpackTo(_o) {
        _o.duration = this.duration();
    }
}
exports.TimeoutSettings = TimeoutSettings;
class TimeoutSettingsT {
    constructor(duration = 0.0) {
        this.duration = duration;
    }
    pack(builder) {
        return TimeoutSettings.createTimeoutSettings(builder, this.duration);
    }
}
exports.TimeoutSettingsT = TimeoutSettingsT;
